export const COLOR_DEGREE_STAIR_VALUE = 30
export const COLOR_SATURATION_STAIR_VALUE = 15
export const COLOR_LUMINOSITY_STAIR_VALUE = 15
export const COLOR_GRAY_STAIR_VALUE = 9
